import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b0b5169"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Download For Windows ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Download For Linux ")
const _hoisted_7 = {
  key: 1,
  class: "content"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Vitaj!", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Vies tu jednoducho najst a nainstalovat si vsetky nase hry, ktore sme naprogramovali na ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.smnd.sk/mikey/PHP/spongia" }, "spongiu", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(". Pre automaticke instalovanie a pohodlne spustanie hier si vies stiahnut nas launcher ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Download Launcher For Windows ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Download Launcher For Linux ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_markdown = _resolveComponent("markdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, null, {
    default: _withCtx(() => [
      (_ctx.game)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.game.Screenshots || _ctx.game.trailer)
              ? (_openBlock(), _createBlock(_component_el_carousel, {
                  key: 0,
                  height: "60vh",
                  style: {"backgroun-color":"black"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.game.trailer)
                      ? (_openBlock(), _createBlock(_component_el_carousel_item, { key: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.game.trailer.match('youtube.com'))
                              ? (_openBlock(), _createElementBlock("iframe", {
                                  key: 0,
                                  src: _ctx.game.trailer,
                                  style: {"width":"100%","height":"100%"}
                                }, null, 8, _hoisted_2))
                              : _createCommentVNode("", true),
                            _createElementVNode("video", {
                              src: _ctx.game.trailer,
                              autoplay: "",
                              style: {"width":"100%","height":"100%"}
                            }, null, 8, _hoisted_3)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.Screenshots, (item) => {
                      return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_image, {
                            src: item,
                            fit: "scale-down",
                            style: {"width":"100%","height":"100%"}
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "No images"
                })),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_markdown, { source: _ctx.description }, null, 8, ["source"]),
              _createVNode(_component_el_button, {
                variant: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadWindows()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                variant: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadLinux()))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", null, [
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _createVNode(_component_el_button, {
                variant: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadLauncherWindows()))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                variant: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadLauncherLinux()))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ]))
    ]),
    _: 1
  }))
}